export default __webpack_public_path__ + "static/media/add1.d0b7ced0.png";